<main>
    <h1>Usted no tiene permisos para acceder a este sitio</h1>

    <h2>Por favor, contacte al administrador del sistema</h2>
    <h2><a href="mailto:zee.tech@vemo.global">zee.tech&#64;vemo.global</a></h2>
</main>
